import { getRequest } from 'utils/request';

export const getResources = (query) => getRequest(`/storage`, query);

export const getFileData = (query) => getRequest(`/storage/sampleData`, query);
